import { useQuery } from '@tanstack/react-query';
import {
  getFinancesSaasEligibleLocations,
  queryKeys,
} from '@vgrubs/components';

/**
 * Locations with no SaaS fee that would qualify for one, as the backend
 * sorts them (by `total`, highest first). Always the last 30 days: the
 * screen's date filter does not apply, so the key has no range and changing
 * the filter does not refetch. Worked out live on every request, but it moves
 * slowly, hence the long stale time.
 */
export const useSaasEligibleLocations = () => {
  const query = useQuery({
    queryKey: queryKeys.admin.saasEligibleLocations,
    queryFn: async () => {
      const { data } = await getFinancesSaasEligibleLocations();
      return data.data ?? [];
    },
    staleTime: 10 * 60 * 1000,
  });

  return {
    locations: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
